import { i18n } from "i18next";

function convertNumberToString(
  float: number,
  i18n: i18n,
  minDecimalCount: number,
  maxDecimalCount: number,
){
  if (float === undefined || isNaN(float)) {
    return "";
  }

  switch (i18n.language)
  { 
    case 'fr' :
      return float.toLocaleString('fr-FR', {
        minimumFractionDigits: minDecimalCount,
        maximumFractionDigits: maxDecimalCount,
      });
    case 'en' :
      return float.toLocaleString('en-EN', {
        minimumFractionDigits: minDecimalCount,
        maximumFractionDigits: maxDecimalCount,
      });
    default:
      return float.toLocaleString('en-EN', {
        minimumFractionDigits: minDecimalCount,
        maximumFractionDigits: maxDecimalCount,
      });
  }
}

export { convertNumberToString }